export interface BillTypeItem {
  title: string;
  code: number;
  color: string;
}

export const BillType: { [key: string]: BillTypeItem } = {
  ALL: {
    title: "全部",
    code: -1,
    color: "#808080",
  },
  DEPOSIT: {
    title: "定金",
    code: 0,
    color: "#9c27b0",
  },
  FREIGHT_PREPAY: {
    title: "运费（预付）",
    code: 1,
    color: "#ff9800",
  },
  FREIGHT_PATCH: {
    title: "运费",
    code: 2,
    color: "#2196f3",
  },
  INBOUND: {
    title: "充值",
    code: 3,
    color: "#4caf50",
  },
  OUTBOUND: {
    title: "提现",
    code: 4,
    color: "#f44336",
  },
};

export const getBillTypeTitle = (code: number): string => {
  const type = Object.values(BillType).find((item) => item.code === code);
  return type?.title || "未知类型";
};

export const getBillTypeColor = (code: number): string => {
  const type = Object.values(BillType).find((item) => item.code === code);
  return type?.color || "#808080";
};

export const getBillTypeChoices = (): Array<{ id: number; name: string }> => {
  return Object.values(BillType).map((item) => ({
    id: item.code,
    name: item.title,
  }));
};

export default BillType;
